import { Variables } from '../base';

export const PDF_BACKGROUND_COLOR = Variables.Colors.n15_24;
export const PDF_RENDER_HOST_STYLES: Partial<CSSStyleDeclaration> = {
    width: '100%',
    margin: '0',
    padding: '0',
    fontFamily: 'Arial, sans-serif',
};

export const PDF_OFFSCREEN_LEFT = '-10000px';
export const PDF_OFFSCREEN_WIDTH = '1200px';
export const ONE_INCH_WIDTH = '1in';

